import { gql } from "@apollo/client";import { useMutation, useQuery } from "@apollo/client/react";import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import toast from 'react-hot-toast';
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';
import '../../../assets/css/App.css';
import { DateInput } from '../../../components/dateInput/DateInput';
import { Grid } from '@mui/material';
import 'moment/locale/es';
import ErrorDialog from '../../../components/ErrorDialog';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import { CustomButton } from '../../../components/customButton/CustomButton';
import EditorTipTap from "../../../components/EditorTipTap/EditorTipTap";

const locale = "es-ES";

export default function TerminoAdminLayout() {

  const { state } = useLocation();

  const navigate = useNavigate();

  const idUsuario = parseInt(sessionStorage.getItem("idUsuario"), 10);

  const { termino, edit } = state;

  const [vigenciaDesde, setVigenciaDesde] = useState(null);

  const [loadingGrabar, setLoadingGrabar] = useState(false);

  const [texto, setTexto] = useState("");

  // dlg de error
  const [opendDlgError, setOpenDlgError] = useState(false);
  const [mensajeError, setMensajeError] = useState("");

  useEffect(() => {
    setOpenDlgError(mensajeError !== "");
  }, [mensajeError]);

  // INICIO CONSULTA DE TERMINO
  const QRegTermino = gql`
        query QRegTermino($idTermino: Int!){
            regTermino(idTermino: $idTermino)
            {
            success,
            error,
            valorEsperado {
                idTermino, 
                texto, 
                vigenciaDesde, 
                vigenciaHasta, 
                version, 
                fechaAlta, 
                usuarioAlta, 
                fechaUltModif, 
                usuarioUltModif
            }
            }            
        }`;

  const { data: dataReg } = useQuery(QRegTermino, {
    fetchPolicy: 'no-cache',
    variables: { idTermino: termino ? termino.idTermino : 0 }
  });
  // FIN CONSULTA DE TERMINO

  const MSaveTermino = gql`
        mutation MSaveTermino (
                $idTermino: Int!, 
                $texto: String!, 
                $vigenciaDesde: String!, 
                $vigenciaHasta: String!, 
                $idUsuario: Int!, $version: Int!) {
            saveTermino (
                idUsuario: $idUsuario,
                model: {
                    idTermino: $idTermino,
                    fecha: "",
                    version: $version,
                    texto: $texto,
                    vigenciaDesde: $vigenciaDesde,
                    vigenciaHasta: $vigenciaHasta
            })
            {
                success,
                error,
                valorEsperado
            }
        }`;

  const [grabarTermino, { data }] = useMutation(MSaveTermino, {
    onCompleted: (data) => {
      setLoadingGrabar(false);
      if (data.saveTermino.success && data.saveTermino.valorEsperado > 0) {
        toast.success("Términos y condiciones actualizados correctamente.");
        setTimeout(() => {
          navigate('/termadmin');
        }, 1000);
      } else if (data.saveTermino.error === 'ERRORDB' || parseInt(data.saveTermino.error, 10) > 0) {
        setMensajeError(data.saveTermino.error);
      } else {
        toast.error(data.saveTermino.error);
      }
    },
    onError: (data) => {
      setLoadingGrabar(false);
      setMensajeError("ERRORDB");
      return false;
    }
  });

  const validarGrabar = (texto, vigenciaDesde) => {

    if (vigenciaDesde == null || vigenciaDesde == "") {
      toast.error("La Fecha Desde de Vigencia es obligatoria.");
      return false;
    }
    if (texto == null || texto == "") {
      toast.error("El Texto es obligatorio.");
      return false;
    }

    return true;
  };

  const handleGrabar = () => {

    let parametros = "";

    const vigDesde = termino != null ? termino.vigenciaDesde : vigenciaDesde;

    if (validarGrabar(texto, vigDesde)) {
      setLoadingGrabar(true);

      // UPDATE
      if (termino != null) {
        parametros = {
          variables: {
            "idTermino": termino.idTermino,
            "idUsuario": idUsuario,
            "texto": texto,
            "vigenciaDesde": moment(vigDesde).format("yyyy-MM-DD"),
            "vigenciaHasta": termino.vigenciaHasta != null && termino.vigenciaHasta != "" ? moment(termino.vigenciaHasta).format("yyyy-MM-DD") : "",
            "version": termino.version
          }
        };
      } else {
        // ALTA
        parametros = {
          variables: {
            "idTermino": 0,
            "idUsuario": idUsuario,
            "texto": texto,
            "vigenciaDesde": moment(vigDesde).format("yyyy-MM-DD"),
            "vigenciaHasta": "",
            "version": 0
          }
        };
      }

      let result = grabarTermino(parametros);
    }
  };

  const handleCancelar = () => {
    navigate('/termadmin');
  };

  const handleChangeDate = (newValue) => {
    setVigenciaDesde(newValue);
  };

  const handleCloseDlgError = () => {
    setOpenDlgError(false);
  };

  return (
    <>
      {
      termino != null && <div className='form-label'><strong>Versión # {termino.version}</strong></div>
      }

      <div className='form-bloque' style={{ width: '100%' }}>
        <Grid container spacing={2} sx={{ width: '100%' }}>          
            {
            termino != null &&
            <Grid size={{ xs: 12, md: 4, lg: 4 }}>
              <div className='form-label' style={{ width: '100%' }}>Vigencia desde <strong>{moment(termino.vigenciaDesde).format("DD/MM/yyyy")}</strong>&nbsp;
                hasta <strong>{termino.vigenciaHasta != "" ? moment(termino.vigenciaHasta).format("DD/MM/yyyy") : "-"}</strong>
              </div>
            </Grid>
            }
            {
            termino == null &&
              <Grid size={{ xs: 12, md: 4, lg: 4 }}>
              <div className='form-label' style={{ width: '90%' }}>
                  <DateInput
                  label="Vigencia desde"
                  disablePast
                  value={vigenciaDesde}
                  onChange={handleChangeDate} />
                
                </div>
              </Grid>
            }
          <Grid size={{ xs: 12, md: 4, lg: 4 }}>&nbsp;</Grid>
          <Grid size={{ xs: 12, md: 4, lg: 4 }}>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
              {
              edit ?

              <CustomButton
                onClick={handleCancelar}
                size="small"
                variant="contained">                
                Cancelar
              </CustomButton> :
              <CustomButton
                onClick={handleCancelar}
                size="small"
                variant="contained">                
                Volver
              </CustomButton>
              }
              &nbsp;&nbsp;&nbsp;&nbsp;
              <CustomButton
                disabled={!edit}
                loading={loadingGrabar}
                loadingPosition="end"
                onClick={handleGrabar}
                size="small"
                variant="contained">                
                Guardar
              </CustomButton>
            </div>
          </Grid>
        </Grid>
      </div>

      <br />
       
      {dataReg && 
        <EditorTipTap
          value={dataReg?.regTermino?.valorEsperado?.texto || ""}
          editable={edit}
          onChange={(html) => setTexto(html)}
        />
      }

      <ErrorDialog
        id="dlg-error-terminos"
        open={opendDlgError}
        onClose={handleCloseDlgError}
        mensaje={mensajeError} />
      
    </>);
}